/**
 * Enum representing Bluetooth connection statuses that should NOT be displayed in the UI.
 * These are the bluetooth connection statuses that we do not want to show when and setting is updated.
 */
export enum BLU_STATUS {
	UNHANDLED_STATE = -1,
	BUTTON_PRESS_REQUIRED = 0,
	DEVICE_PROCESSED = 2,
	DEVICE_OTA_REQUIRED = 6,
	DEVICE_OTA_AVAILABLE = 7,
	CONNECT_TO_DEVICE = 19,
	DISCONNECT_FROM_DEVICE = 21,
	OTA_PROGRESS = 30,

	ENCRYPTING_DEVICE = 11,
	DEVICE_ENCRYPTED = 12,
	DECRYPTING_DEVICE = 42,
	DEVICE_DECRYPTED = 43,

	BUZZER_TURNED_ON = 44,
	BUZZER_TURNED_OFF = 45,
	BEACON_ENABLED = 46,
	BEACON_DISABLED = 47,
	BUZZER_ENABLED = 48,
	BUZZER_DISABLED = 49,

	MOTION_LED_ENABLED = 51,
	MOTION_LED_DISABLED = 52,
	BLIND_TIME_SET = 53,
	SENSITIVITY_SET = 54,
	DISTANCE_RANGE_SET = 57,
	INTERVAL_MEASURE_SET = 58,
	MEASURE_VIBRATION_ENABLED = 59,
	MEASURE_VIBRATION_DISABLED = 60,

	MIN_ANGLE_THRESHOLD_SET = 61,
	UTC_OFFSET_SET = 62,
	TEMPERATURE_OFFSET_SET = 63,
	HUMIDITY_OFFSET_SET = 64,
	DARK_THRESHOLD_SET = 65,
	BRIGHT_THRESHOLD_SET = 66,

	INVERT_DISPLAY_ENABLED = 67,
	INVERT_DISPLAY_DISABLED = 68,
	FAHRENHEIT_ENABLED = 69,
	FAHRENHEIT_DISABLED = 70,
	CLOCK_SYNC_ENABLED = 71,
	CLOCK_SYNC_DISABLED = 72,
	POWER_SAVER_ENABLED = 73,
	POWER_SAVER_DISABLED = 74,
	ZIGBEE_ENABLED = 75,
	ZIGBEE_DISABLED = 76,
	SMOKE_THRESHOLD_SET = 77,
	TEMPERATURE_THRESHOLD_SET = 78,
	FIRE_GROUP_SET = 79,
	CLOCK_MODE_SET = 80,
}

/**
 * Show every possible ble connection status, except of:
 */
export const BLU_CONN_STATUSES_THAT_DO_NOT_SHOW: BLU_STATUS[] = Object.values(BLU_STATUS).filter(
	(value) =>
		![
			BLU_STATUS.UNHANDLED_STATE,
			BLU_STATUS.BUTTON_PRESS_REQUIRED,
			BLU_STATUS.CONNECT_TO_DEVICE,
			BLU_STATUS.DISCONNECT_FROM_DEVICE,
		].includes(value as BLU_STATUS),
) as BLU_STATUS[];
